module.exports = __webpack_public_path__ + "static/img/7.6811a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/7.jpg
// module id = ZwV9
// module chunks = 2